import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import "./style/HighlightPopup.css";

const HighlightPopup = ({ highlight, editComment, deleteComment }) => {
  const handleEdit = () => {
    editComment(highlight.id);
  };

  const handleDelete = () => {
    deleteComment(highlight.id);
  };
  return highlight.comment ? (
    <div className="Highlight__popup">
      <div style={{ textAlign: "right", marginBottom: "0.5rem" }}>
        <FontAwesomeIcon
          icon={faEdit}
          style={{ cursor: "pointer" }}
          onClick={handleEdit}
        />
        <FontAwesomeIcon
          icon={faTrashAlt}
          style={{ cursor: "pointer", marginLeft: "1rem" }}
          onClick={handleDelete}
        />
      </div>
      <div dangerouslySetInnerHTML={{ __html: highlight.comment }} />
    </div>
  ) : (
    <div className="Highlight__popup">
      <div style={{ textAlign: "right", marginBottom: "0.5rem" }}>
        <FontAwesomeIcon
          icon={faEdit}
          style={{ cursor: "pointer" }}
          onClick={handleEdit}
        />
        <FontAwesomeIcon
          icon={faTrashAlt}
          style={{ cursor: "pointer", marginLeft: "1rem" }}
          onClick={handleDelete}
        />
      </div>
      <div>Comment has no Text</div>
    </div>
  );
};

export default HighlightPopup;
